import React, { useEffect, useRef, useState } from "react";
import BetMenu from "../../components/games/roulette/BetMenu";
import ManualBet from "../../components/games/roulette/ManualBet";
import anime from "animejs";
import { useWallet } from "../../hooks/useWallet";
import chips1Url from "../../assets/chips/chips1.svg";
import chips10Url from "../../assets/chips/chips10.svg";
import chips100Url from "../../assets/chips/chips100.svg";
import chips1kUrl from "../../assets/chips/chips1k.svg";
import chips1mUrl from "../../assets/chips/chips1m.svg";
import chips10mUrl from "../../assets/chips/chips10m.svg";
import { LuWallet } from "react-icons/lu";
import chips50mUrl from "../../assets/chips/chips50m.svg";
import ChipsList from "../../components/games/roulette/ChipsList";
import blazLogoUrl from "../../assets/blazpointsLogo.svg";
import Board from "../../components/games/roulette/Board";
import TransactionHistory from "../../components/games/roulette/TransactionHistory";
import { toast } from "react-toastify";
import axios from "axios";
import "../../components/games/roulette/wheel.css";
import boardCells from "../../components/games/roulette/contants";
import RouletteWallet from "../../components/games/roulette/RouletteWallet";
import RouletteWheel from "../../components/games/roulette/RouletteWheel";
import { ethers } from "ethers";
import RouletteModal from "../../components/games/roulette/RouletteModal";
const chipsList = [
  { value: 1, url: chips1Url, color: "#200052" },
  { value: 10, url: chips10Url, color: "#a100e0" },
  { value: 100, url: chips100Url, color: "#bc8b09" },
  { value: 1000, url: chips1kUrl, color: "#00d087" },
  { value: 10_00000, url: chips1mUrl, color: "#200052" },
  { value: 100_00000, url: chips10mUrl, color: "#007878" },
  { value: 500_00000, url: chips50mUrl, color: "#0170b5" },
];
const Roulette = () => {
  const [selectedMenu, setSelectedMenu] = useState("bet");
  const [selectedChips, setSelectedChips] = useState([]);
  const [isWalletActive, setIsWalletActive] = useState(false);
  const [balance, setBalance] = useState(0);
  const [responseData, setResponseData] = useState({});
  const [isActiveModal, setIsActiveModal] = useState(false);
  const [lastNumber, setLastNumber] = useState([]);
  const [affectedBalance, setAffectedBalance] = useState(Date.now());
  const [stack, setStack] = useState([]);
  const [board, setBoard] = useState(boardCells);
  const [resetKey, setResetKey] = useState(false);
  const [total, setTotal] = useState(0);
  const [lastUndoAction, setLastUndoAction] = useState({});
  const walletRef = useRef(null);
  const wallet = useWallet();

  const handleSpinWheel = (number) => {
    let totalNumbers = 37;
    let singleSpinDuration = 5000;
    let singleRotationDegree = 360 / totalNumbers;
    let lastNumber = 0;
    let rouletteWheelNumbers = [
      0, 32, 15, 19, 4, 21, 2, 25, 17, 34, 6, 27, 13, 36, 11, 30, 8, 23, 10, 5,
      24, 16, 33, 1, 20, 14, 31, 9, 22, 18, 29, 7, 28, 12, 35, 3, 26,
    ];
    const bezier = [0.165, 0.84, 0.44, 1.005];
    let ballMinNumberOfSpins = 2;
    let ballMaxNumberOfSpins = 4;
    let wheelMinNumberOfSpins = 2;
    let wheelMaxNumberOfSpins = 4;

    const getRouletteIndexFromNumber = (number) => {
      return rouletteWheelNumbers.indexOf(parseInt(number));
    };
    const nextNumber = (number) => {
      let value = number;
      return value;
    };
    const getRotationFromNumber = (number) => {
      let index = getRouletteIndexFromNumber(number);
      return singleRotationDegree * index;
    };

    const getRandomEndRotation = (minNumberOfSpins, maxNumberOfSpins) => {
      let rotateTo = anime.random(
        minNumberOfSpins * totalNumbers,
        maxNumberOfSpins * totalNumbers
      );

      return singleRotationDegree * rotateTo;
    };
    const getZeroEndRotation = (totalRotaiton) => {
      let rotation = 360 - Math.abs(totalRotaiton % 360);

      return rotation;
    };
    const getBallEndRotation = (zeroEndRotation, currentNumber) => {
      return Math.abs(zeroEndRotation) + getRotationFromNumber(currentNumber);
    };

    const getBallNumberOfRotations = (minNumberOfSpins, maxNumberOfSpins) => {
      let numberOfSpins = anime.random(minNumberOfSpins, maxNumberOfSpins);
      return 360 * numberOfSpins;
    };

    let currentNumber = nextNumber(number);
    let lastNumberRotation = getRotationFromNumber(lastNumber.toString());
    let endRotation = -getRandomEndRotation(
      ballMinNumberOfSpins,
      ballMaxNumberOfSpins
    );
    let zeroFromEndRotation = getZeroEndRotation(endRotation);
    let ballEndRotation =
      getBallNumberOfRotations(wheelMinNumberOfSpins, wheelMaxNumberOfSpins) +
      getBallEndRotation(zeroFromEndRotation, currentNumber);

    anime.set([".layer-2", ".layer-4"], {
      rotate: function () {
        return lastNumberRotation;
      },
    });
    anime.set(".ball-container", {
      rotate: function () {
        return 0;
      },
    });

    anime({
      targets: [".layer-2", ".layer-4"],
      rotate: function () {
        return endRotation;
      },
      duration: singleSpinDuration,
      easing: `cubicBezier(${bezier.join(",")})`,
      complete: function (anim) {
        lastNumber = currentNumber;
      },
    });
    anime({
      targets: ".ball-container",
      translateY: [
        { value: 0, duration: 2000 },
        { value: 20, duration: 1000 },
        { value: 25, duration: 900 },
        { value: 50, duration: 1000 },
      ],
      rotate: [{ value: ballEndRotation, duration: singleSpinDuration }],
      loop: 1,
      easing: `cubicBezier(${bezier.join(",")})`,
    });
  };
  const getLastNumber = async () => {
    const response = await axios.get("/api/game/roulette/lastnumbers?limit=5");
    return response;
  };
  const handleBet = async () => {
    setResponseData({});
    setIsActiveModal(false);
    const bets = [];
    const singleBets = [];

    // Process bets from the board
    board.forEach((row) => {
      row.forEach((cell) => {
        if (cell.chips && cell.chips.length > 0 && cell.value !== -1) {
          // Calculate total amount for this cell from all placed chips
          const totalAmount = cell.chips.reduce((sum, chip) => {
            return sum + chip.value * chip.count;
          }, 0);

          if (totalAmount > 0) {
            // Handle range bets
            if (typeof cell.value === "string" && cell.value.includes("-")) {
              bets.push({
                type: "range",
                range: cell.value,
                amount: totalAmount,
              });
            }
            // Handle red/black bets
            else if (cell.value === "red" || cell.value === "black") {
              bets.push({
                type: "redBlack",
                range: cell.value,
                amount: totalAmount,
              });
            }
            // Handle even/odd bets
            else if (cell.value === "even" || cell.value === "odd") {
              bets.push({
                type: "evenOdd",
                range: cell.value,
                amount: totalAmount,
              });
            }
            // Handle row bets
            else if (
              cell.value === "first" ||
              cell.value === "second" ||
              cell.value === "third"
            ) {
              bets.push({
                type: "row",
                row: cell.value,
                amount: totalAmount,
              });
            }
            // Handle single number bets
            else {
              singleBets.push({
                number: cell.value,
                amount: totalAmount,
              });
            }
          }
        }
      });
    });

    // Add single number bets if any exist
    if (singleBets.length > 0) {
      bets.push({
        type: "single",
        numbers: singleBets,
      });
    }

    if (bets.length === 0) {
      toast.error("No bets placed!");
      return;
    }

    try {
      const response = await axios.post("/api/game/roulette", {
        bets,
        chainId: wallet?.chainId,
      });
      const winningNumber = response?.winningNumber;
      handleSpinWheel(winningNumber);
      setResponseData(response);
      anime({
        targets: ".ball-container",
        duration: 5000,
        easing: "linear",
        complete: async function () {
          setBalance(response?.updatedBalance);
          setIsActiveModal(true);
          const lastNumberResponse = await getLastNumber();
          setLastNumber(lastNumberResponse);
          setTimeout(() => {
            setIsActiveModal(false);
          }, 3000);
        },
      });
    } catch (error) {
      console.error(error?.response?.data?.message);
      toast.error(error?.response?.data?.message || "Failed to place bet");
    }
  };
  const handlePlaceChips = (value) => {
    if (total > balance) {
      toast.error("No more chips to place, deposit more funds");
      return;
    }
    if (!selectedChips?.length) {
      toast.info("No chips selected!");
      return;
    }
    const currentChips = selectedChips[0];
    const totalValue = total + currentChips?.value;
    if (totalValue > balance) {
      toast.error("No more chips to place, deposit more funds");
      return;
    }
    setTotal(totalValue);
    setBoard((prevBoard) =>
      prevBoard.map((row) =>
        row.map((cell) => {
          if (cell.value === value) {
            const totalChipCount = cell.chips.reduce(
              (sum, chip) => sum + chip.count,
              0
            );
            const chipExists = cell.chips.find(
              (chip) => chip.value === currentChips?.value
            );

            if (chipExists) {
              if (totalChipCount > 10) {
                toast.warning("Maximum chip count reached");
                return cell;
              }
              const updatedBoard = {
                ...cell,
                chips: cell.chips.map((chip) =>
                  chip.value === currentChips.value
                    ? { ...chip, count: Math.min(chip.count + 1, 10) }
                    : chip
                ),
              };
              setStack((prevStack) => [
                ...prevStack,
                { value, chipValue: currentChips.value },
              ]);

              return updatedBoard;
            } else {
              const newCell = {
                ...cell,
                chips: [...cell.chips, { ...currentChips, count: 1 }],
              };

              setStack((prevStack) => [
                ...prevStack,
                { value, chipValue: currentChips.value },
              ]);

              return newCell;
            }
          }
          return cell;
        })
      )
    );
  };
  const handleUndo = () => {
    if (stack.length === 0) {
      toast.info("Nothing to undo!");
      return;
    }
    const lastAction = stack[stack?.length - 1];
    setStack((prevStack) => prevStack.slice(0, -1));
    setTotal((prevTotal) => Math.max(prevTotal - lastAction.chipValue, 0));
    setBoard((prevBoard) =>
      prevBoard.map((row) =>
        row.map((cell) => {
          if (cell.value === lastAction.value) {
            const updatedChips = cell.chips
              .map((chip) =>
                chip.value === lastAction.chipValue
                  ? { ...chip, count: chip.count - 1 }
                  : chip
              )
              .filter((chip) => chip.count > 0);

            return { ...cell, chips: updatedChips };
          }
          return cell;
        })
      )
    );

    setLastUndoAction(lastAction);
  };
  const handleSelectChips = (value, url) => {
    if (value > balance) {
      toast.info("Deposit more funds to play with such chips!");
      return;
    }

    setSelectedChips((prevChips) => {
      const existingIndex = prevChips.findIndex((chip) => chip.value === value);
      if (existingIndex !== -1) {
        const updatedChips = [...prevChips];
        const [selectedChip] = updatedChips.splice(existingIndex, 1);
        return [selectedChip, ...updatedChips];
      }
      return [{ value, url }, ...prevChips];
    });
  };
  const handleClearBoard = () => {
    setTotal(0);
    setBoard((prevBoard) =>
      prevBoard.map((row) =>
        row.map((cell) => ({
          ...cell,
          chips: cell.chips.map((chip) => ({
            ...chip,
            count: 0,
          })),
        }))
      )
    );
    setResetKey(true);
  };
  const getCellColor = (cellNumber) => {
    return (
      board.flatMap((row) =>
        row
          .filter((item) => item.value === cellNumber)
          .map((item) => item.color)
      )[0] || ""
    );
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (walletRef.current && !walletRef.current.contains(event.target)) {
        setIsWalletActive(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const fetchBalance = async () => {
      try {
        const response = await axios.get(
          `/api/game/wallet?chainId=${wallet.chainId}&gameType=roulette`
        );
        if (response) {
          setBalance(response?.balance);
        }
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch balance");
      }
    };
    fetchBalance();
  }, [wallet, affectedBalance]);
  const TAB = [
    {
      value: "bet",
      element: (
        <ManualBet
          logoUrl={blazLogoUrl}
          setChips={setSelectedChips}
          chips={selectedChips}
          chipsList={chipsList}
          balance={balance}
          handleBet={handleBet}
          handleSelectChips={handleSelectChips}
          total={total}
        />
      ),
    },
    {
      value: "history",
      element: <TransactionHistory />,
    },
  ];

  return (
    <div className="min-h-screen xl:pb-5 pb-24  relative w-full sm:pt-[88px] pt-20">
      <ChipsList chipsList={chipsList} selectedChips={selectedChips} />
      <div className=" 2xl:container w-full  mx-auto 2xl:px-24 lg:px-12 text-white flex xl:flex-row flex-col 2xl:gap-x-12 gap-x-8 items-start">
        <div className="flex flex-col items-center xl:order-1 order-2 xl:w-[63%] w-full xsm:h-full h-[680px]">
          <div className="flex xl:w-full lg:container w-full z-20 xl:relative absolute xl:top-0 top-24 2xl:justify-start justify-between items-center 2xl:px-0 xl:px-12 lg:px-8 sm:px-12 xs:px-10 px-6 2xl:gap-x-8">
            <RouletteModal
              isActive={isActiveModal}
              className={"absolute left-1/2 top-40 -translate-x-1/2  z-30"}
              cellNumber={responseData?.winningNumber}
              amount={responseData?.winAmount?.toFixed(5)}
              range={(
                responseData?.winAmount / responseData?.totalBetAmount
              ).toFixed(2)}
              status={responseData?.won ? "win" : "failed"}
              color={getCellColor(responseData?.winningNumber)}
              logo={blazLogoUrl}
            />
            <h1
              className={`2xl:text-6xl lg:text-5xl sm:text-4xl xsm:text-3xl text-2xl    relative   font-bold font-akira `}
            >
              Roulette
            </h1>
            <div
              ref={walletRef}
              onClick={(e) => {
                e.stopPropagation();
                setIsWalletActive(true);
              }}
              className="md:px-7  sm:px-4 px-2 cursor-pointer relative flex items-center h-fit sm:py-3 xsm:py-2 xs:py-1 py-0.5 bg-black border border-[#434343] md:gap-x-3 sm:gap-x-2 gap-x-1 rounded-lg"
            >
              <LuWallet className="sm:text-xl xsm:text-base xs:text-xs text-[10px] text-[#200052] hover:opacity-70 transition-all duration-250 ease-in-out" />

              <h1
                className={`${
                  balance < 5000000
                    ? "md:text-base text-sm"
                    : "md:text-xs text-[10px]"
                }  font-semibold hover:opacity-70 transition-all duration-250 ease-in-out`}
              >
                {balance === 0 ? (
                  "Deposit Blazpoints to play"
                ) : (
                  <span className="sm:text-base xs:text-xs text-[8px]">
                    Roulette Balance : {balance}
                  </span>
                )}
              </h1>
              <RouletteWallet
                logoUrl={blazLogoUrl}
                isActive={isWalletActive}
                newBalance={balance}
                setAffectedBalance={setAffectedBalance}
                className={
                  "absolute top-[56px] xl:left-1/2 right-0 xl:-translate-x-1/2 z-30"
                }
              />
            </div>
          </div>

          <div className="w-full relative">
            <div
              style={{
                backgroundColor: `${getCellColor(
                  lastNumber?.[0]?.winningNumber
                )}`,
              }}
              className="absolute top-1/2  2xl:mt-0 -mt-12 text-white md:text-2xl text-xl xl:flex hidden items-center justify-center font-semibold -translate-y-1/2 md:h-20 md:w-20 h-16 w-16 2xl:left-20 xl:left-32  rounded-xl"
            >
              {lastNumber?.[0]?.winningNumber}
            </div>

            <div className=" z-0 relative xl:block hidden 2xl:top-0 -top-12 h-fit w-full">
              <RouletteWheel />
            </div>

            <div className="absolute top-1/2  2xl:mt-0 -mt-12 -translate-y-1/2 2xl:right-28 xl:right-32  text-white text-3xl xl:flex hidden 2xl:gap-y-2 gap-y-1 flex-col items-center md:w-12 w-10 ">
              {lastNumber?.map((item, index) => {
                return (
                  <div
                    style={{
                      backgroundColor: `${getCellColor(item?.winningNumber)}`,
                      opacity: `${index !== 0 && 1.5 / index}`,
                    }}
                    className="md:w-12 md:h-12 w-10 h-10 rounded-lg md:text-base text-sm flex items-center justify-center text-white"
                  >
                    {item?.winningNumber}
                  </div>
                );
              })}
            </div>
          </div>
          <Board
            board={board}
            handlePlaceChips={handlePlaceChips}
            selectedChips={selectedChips?.[0]}
            setBoard={setBoard}
            handleUndo={handleUndo}
            lastUndoAction={lastUndoAction}
            balance={balance}
            total={total}
            setTotal={setTotal}
            handleClearBoard={handleClearBoard}
            resetKey={resetKey}
            setResetKey={setResetKey}
          />
        </div>
        <div className="flex md:flex-row flex-col items-center xl:pt-10  xl:pl-0 lg:pl-20 md:pl-12 xs:pl-0 pl-5 lg:pr-0 md:pr-12 xs:pr-0 pr-5  relative xl:top-0 top-20 xl:justify-end justify-between   xl:order-2 order-1 xl:w-[37%]  w-full mx-auto">
          <div className="z-0 xl:hidden  move-left  xsm:w-fit xs:w-[360px] w-[330px] flex items-center justify-center  relative  xsm:h-fit xs:h-[360px] h-[330px]">
            <div
              style={{
                backgroundColor: `${getCellColor(
                  lastNumber?.[0]?.winningNumber
                )}`,
              }}
              className="absolute  xl:hidden  lg:-left-16 sm:-left-4 xs:-left-8 -left-5  top-1/2 -translate-y-1/2    text-white md:text-2xl sm:text-xl flex items-center justify-center font-semibold  lg:h-20 lg:w-20 xs:h-16 h-12 xs:w-16 w-12 rounded-xl"
            >
              {lastNumber?.[0]?.winningNumber}
            </div>
            <RouletteWheel />
            <div className="absolute  lg:-right-8 -right-4 top-1/2 -translate-y-1/2   text-white text-3xl xl:hidden flex 2xl:gap-y-2 gap-y-1 flex-col items-center md:w-12 w-10 ">
              {lastNumber?.map((item, index) => {
                return (
                  <div
                    style={{
                      backgroundColor: `${getCellColor(item?.winningNumber)}`,
                      opacity: `${index !== 0 && 1.5 / index}`,
                    }}
                    className="md:w-12 md:h-12 w-10 h-10 rounded-lg md:text-base xs:text-sm text-[10px] flex items-center justify-center text-white"
                  >
                    {item?.winningNumber}
                  </div>
                );
              })}
            </div>
          </div>
          <div className="2xl:w-full xl:w-[90%] lg:w-[400px]  md:w-[320px] sm:w-[400px]  xs:w-[360px] w-full border lg:px-6 md:px-4 xs:px-6 px-4 border-[#434343] bg-black rounded-[20px] 2xl:h-[600px] lg:h-[560px] md:h-[460px] sm:h-[520px] h-[480px] relative ">
            <BetMenu selected={selectedMenu} setSelected={setSelectedMenu} />
            {TAB.map((tab) => tab.value === selectedMenu && tab.element)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Roulette;
